import clsx from 'clsx'
import React, { ComponentPropsWithRef } from 'react'

import styles from './ProductTileWrapper.module.scss'

export const ProductTileWrapper = ({
  children,
  className,
  maxColumns = 4,
  showMore = false,
  ...props
}: ComponentPropsWithRef<'div'> & {
  maxColumns?: 4 | 8
  showMore?: boolean
}) => (
  <div
    className={clsx(
      styles.productTileWrapper,
      maxColumns === 4 && styles.maxFour,
      maxColumns === 8 && styles.maxEight,
      showMore && styles.showMore,
      className,
    )}
    {...props}
  >
    {children}
  </div>
)
